var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBarPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_114_1",
    "data-name": "Componente 114 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.843,
    height: 22.843,
    viewBox: "0 0 22.843 22.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9212",
    "data-name": "Trazado 9212",
    d: "M19.274,15.7h-5a2.142,2.142,0,1,1,0-4.283H18.56s4.283-4.774,4.283-7.138a4.283,4.283,0,0,0-8.566,0c0,1.544,1.825,4.113,3.092,5.711H14.277a3.569,3.569,0,1,0,0,7.138h5a2.142,2.142,0,1,1,0,4.283H5.474c1.267-1.6,3.092-4.167,3.092-5.711A4.283,4.283,0,0,0,0,15.7c0,2.365,4.283,7.138,4.283,7.138H19.274a3.569,3.569,0,1,0,0-7.138ZM15.7,4.283a2.855,2.855,0,0,1,5.711,0c0,.91-1.343,3.034-2.855,4.925C17.043,7.308,15.7,5.166,15.7,4.283ZM1.428,15.7a2.855,2.855,0,0,1,5.711,0c0,.91-1.343,3.034-2.855,4.925C2.766,18.729,1.428,16.588,1.428,15.7Zm2.855-.714a.714.714,0,0,0,0,1.428A.714.714,0,0,0,4.283,14.991ZM18.56,3.569A.714.714,0,0,0,18.56,5,.714.714,0,0,0,18.56,3.569Z",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBarPlan);
export default __webpack_public_path__ + "static/media/ico-bar-plan.c8592ac95d2317316cb7b6ab8aed4867.svg";
export { ForwardRef as ReactComponent };